import React from "react";

function resolveLabel(
    labels,
    group,
    key
) {
    if (
        !labels ||
        !labels[group] ||
        !labels[group][key]
    ) {
        return key;
    }

    return labels[group][key];
}

export default function DecorativeFleetVehicleCard({
    profile,
    labels,
    onClose,
}) {
    return (
        <article
            className="decorative-fleet-map__vehicle-card"
            aria-live="polite"
        >
            <div className="decorative-fleet-map__vehicle-card-header">
                <div>
                    <span>
                        {labels.demo}
                    </span>

                    <strong>
                        {profile.driver}
                    </strong>
                </div>

                <button
                    type="button"
                    aria-label={
                        labels.close
                    }
                    onClick={onClose}
                >
                    ×
                </button>
            </div>

            <div className="decorative-fleet-map__vehicle-status">
                <span/>

                {resolveLabel(
                    labels,
                    "statuses",
                    profile.status
                )}
            </div>

            <dl>
                <div>
                    <dt>
                        {labels.trip}
                    </dt>

                    <dd>
                        {profile.trip}
                    </dd>
                </div>

                <div>
                    <dt>
                        {labels.vehicle}
                    </dt>

                    <dd>
                        {profile.vehicle}
                    </dd>
                </div>

                <div>
                    <dt>
                        {labels.route}
                    </dt>

                    <dd>
                        {resolveLabel(
                            labels,
                            "cities",
                            profile.from
                        )}

                        {" → "}

                        {resolveLabel(
                            labels,
                            "cities",
                            profile.to
                        )}
                    </dd>
                </div>

                <div>
                    <dt>
                        {labels.cargo}
                    </dt>

                    <dd>
                        {resolveLabel(
                            labels,
                            "cargos",
                            profile.cargo
                        )}

                        {" · "}

                        {profile.weight}

                        {" "}

                        {labels.tonnes}
                    </dd>
                </div>

                <div>
                    <dt>
                        {labels.eta}
                    </dt>

                    <dd>
                        {profile.eta}
                    </dd>
                </div>
            </dl>
        </article>
    );
}
